export function groupBy<V, K>(
  iterable: Iterable<V>,
  predicate: (item: V, index: number) => K,
): Map<K, Array<V>> {
  const map = new Map();
  let index = 0;
  for (const v of iterable) {
    const key = predicate(v, index);
    let list = map.get(key);
    if (!list) {
      list = [];
      map.set(key, list);
    }
    list.push(v);
    index++;
  }
  return map;
}

export function keyBy<V, K>(
  iterable: Iterable<V>,
  predicate: (item: V, index: number) => K,
): Map<K, V> {
  const map = new Map();
  let index = 0;
  for (const value of iterable) {
    const key = predicate(value, index);
    map.set(key, value);
    index++;
  }
  return map;
}

interface ConstructableIterable<Y> {
  constructor(iterable?: Iterable<Y> | null | undefined): void;
  // @ts-expect-error TS2552
  iterator(): $Iterator<Y, void, void>;
}

export function sortBy<V, I extends ConstructableIterable<V>>(
  iterable: I,
  predicate: (arg1: V, arg2: V) => number,
): I {
  if (Array.isArray(iterable)) {
    // @ts-expect-error - TS2322 - Type 'any[]' is not assignable to type 'I'.
    return iterable.slice().sort(predicate);
  } else {
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type. | TS2345 - Argument of type 'unknown[]' is not assignable to parameter of type 'Iterable<V>'. | TS2769 - No overload matches this call. | TS2345 - Argument of type '(arg1: V, arg2: V) => number' is not assignable to parameter of type '(a: unknown, b: unknown) => number'.
    return new iterable.constructor(Array.from(iterable).sort(predicate));
  }
}

export function* flat<V>(iterable: Iterable<Iterable<V>>): Iterable<V> {
  for (const list of iterable) {
    for (const item of list) {
      yield item;
    }
  }
}
